import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04fb3bd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-pro-multi-tab-fixed"
}
const _hoisted_2 = { class: "header-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_ctx.cacheListLength)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.fixed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_breadcrumb, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString((_ctx.store.cacheList && _ctx.store.cacheList[_ctx.store.cacheList.length - 1].tabTitle) ?
          _ctx.store.cacheList[_ctx.store.cacheList.length - 1].tabTitle : _ctx.store.cacheList[_ctx.store.cacheList.length -
            1].route.meta.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 64))
    : _createCommentVNode("", true)
}